export default "__VITE_ASSET__7905a355__"